import React from 'react'
import { Form } from 'react-bootstrap'

export default function InputPassword({
  value,
  onChange,
  className = '',
  ...other
}) {
  const regex = /^[A-Za-z0-9._@!*#]+$/

  return (
    <Form.Control
      maxLength={15}
      className={`form-control ${className}`}
      value={value}
      onChange={(e) => {
        if (e.target.value.match(regex)) {
          onChange(e)
        } else {
          if (e.target.value.length < 1) {
            onChange(e)
          }
        }
      }}
      {...other}
    />
  )
}
